import { useInfoCenterPrivate } from '@content-api/provider';
import { DashboardCard } from '@pages/dashboard/components';
import { useQuery } from '@tanstack/react-query';
import { Typography } from '@ui/components';
import { cn } from '@ui/utils';
import React from 'react';

export const DashboardBanner = (props: React.ComponentPropsWithoutRef<'div'>) => {
  const { className, ...rest } = props;

  const { getDashboardBanner } = useInfoCenterPrivate();

  const { data: banner } = useQuery({
    queryKey: ['dashboard-banner'],
    queryFn: () => getDashboardBanner(),
  });

  if (!banner) return null;

  return (
    <DashboardCard
      className={cn(
        `bg-cover bg-center`,
        {
          'cursor-pointer': !!banner?.data?.url,
        },
        className,
      )}
      onClick={() => {
        if (banner?.data?.url) {
          window.open(banner?.data?.url, '_blank');
        }
      }}
      style={{
        backgroundImage: `url(${banner?.data.image?.url})`,
      }}
      {...rest}
    >
      <Typography className="text-white" variant="h400">
        {banner?.data.title}
      </Typography>
    </DashboardCard>
  );
};
